import React,{useEffect,useRef,useState} from "react";
export default function LazyChatImage(props){
  const [visible,setVisible]=useState(false),host=useRef(null);
  useEffect(()=>{
    if(visible||!host.current||typeof IntersectionObserver==="undefined")return undefined;
    const observer=new IntersectionObserver(entries=>{
      if(entries.some(entry=>entry.isIntersecting)){setVisible(true);observer.disconnect();}
    });
    observer.observe(host.current);
    return()=>observer.disconnect();
  },[visible]);
  if(visible)return <img {...props} loading="lazy" alt={props.alt||"Imagem da conversa"}/>;
  return <div ref={host} style={{minHeight:100,maxWidth:"100%",display:"grid",placeItems:"center"}}>
    <button type="button" onClick={()=>setVisible(true)}>Carregar imagem</button>
  </div>;
}
